import * as c from '../constants/SettingsConstants'

const initialState = {
  contactInfo: {},
  fetching: false,
  fetched: false,
  error: null
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case c.FETCH_CONTACT_INFORMATION_PENDING:
      return { ...state, fetching: true, fetched: false, error: null }

    case c.FETCH_CONTACT_INFORMATION_FULFILLED:
      return {
        ...state,
        fetching: false,
        fetched: true,
        contactInfo: {
          ...state.contactInfo,
          [payload.orgId]: payload.data
        }
      }

    case c.FETCH_CONTACT_INFORMATION_REJECTED:
      return { ...state, fetching: false, fetched: false, error: payload }

    default:
      return state
  }
}
